
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("crJQR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3811ccaed68e1983$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $3811ccaed68e1983$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': "\u905E\u589E",
    'fabric.editor.headingLink.copied': "\u5DF2\u8907\u88FD\uFF01",
    'fabric.editor.headingLink.copyAnchorLink': "\u8907\u88FD\u6A19\u984C\u9023\u7D50",
    'fabric.editor.headingLink.copyAriaLabel': "\u8907\u88FD",
    'fabric.editor.headingLink.descSortingLabel': "\u905E\u6E1B",
    'fabric.editor.headingLink.failedToCopy': "\u8907\u88FD\u5931\u6557",
    'fabric.editor.headingLink.noneSortingLabel': "\u7121",
    'fabric.editor.inlineComment.marker.end': "\u5167\u5D4C\u7559\u8A00\u7D50\u675F",
    'fabric.editor.inlineComment.marker.start': "\u5167\u5D4C\u7559\u8A00\u958B\u59CB"
};

});


//# sourceMappingURL=zh_TW.1c078e61.js.map
